import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('LAB_RESEARCH_ORDER_DEFAULT')